import { Order } from 'shared/types/cart/Order';

export const PAYMENT_METHODS = {
  SCHEME: 'scheme',
  PAYPAL: 'paypal',
  GOOGLEPAY: 'googlepay',
  APPLEPAY: 'applepay',
} as const;

export type PaymentMethodType = typeof PAYMENT_METHODS[keyof typeof PAYMENT_METHODS];

export interface PaymentProviderMethod {
  name: string;
  type: PaymentMethodType;
  image: {
    src: string;
  };
}

export interface RedirectAction {
  type: 'redirect';
  method: string;
  data?: unknown;
  url: string;
  paymentMethodType: string;
}

export interface ThreeDS2Action {
  type: 'threeDS2';
  authorisationToken: string;
  paymentData: string;
  paymentMethodType: string;
  subtype: string;
  token: string;
  url: string;
}
export type PaymentAction = RedirectAction | ThreeDS2Action;

export type PaymentResponse = {
  additionalData: Record<string, string>;
  pspReference: string;
  resultCode:
    | 'Authorized'
    | 'Cancelled'
    | 'Error'
    | 'Refused'
    | 'RedirectShopper'
    | 'IdentifyShopper'
    | 'ChallengeShopper';
  merchantReference: string;
  action?: PaymentAction;
  order?: Order | null;
  orderCreationFailed?: boolean;
};

export interface SchemeData {
  type: typeof PAYMENT_METHODS.SCHEME;
  brand: string;
  holderName: string;
  number: string;
  expiryMonth: string;
  expiryYear: string;
  lastFour: string;
}

export interface PayPalData {
  type: typeof PAYMENT_METHODS.PAYPAL;
  email: string;
  payerId: string;
  firstName: string;
  lastName: string;
}

export interface GooglePayData {
  type: typeof PAYMENT_METHODS.GOOGLEPAY;
  cardType: string;
  lastFour: string;
}

export interface ApplePayData {
  type: typeof PAYMENT_METHODS.APPLEPAY;
  cardType: string;
  lastFour: string;
}

export type PaymentData = SchemeData | PayPalData | GooglePayData | ApplePayData;

export interface PaymentProvider {
  paymentData: PaymentData;
  paymentDataIsValid: boolean;
  processing: boolean;
  setProcessing: (val: boolean) => void;
  setPaymentData: (data: PaymentData) => void;
  setPaymentDataIsValid: (val: boolean) => void;
  getPaymentMethods: () => Promise<PaymentProviderMethod[]>;
  makePayment: () => Promise<PaymentResponse>;
  preparePayment: () => Promise<string>;
}
